module.exports = __webpack_public_path__ + "static/media/setupusersicons.587ae1a8.svg";